import React, {useState, useContext} from 'react'
import { getLoans,putLoans } from '../api/loans'
import { AuthContext } from '../context/AuthContext';

export const useLoans = () => {
  const [loans, setLoans] = useState([]);
  const [totalPages, setTotalPages] = useState(1)
  const {setLoading,checkToken} = useContext(AuthContext);

  const getAllLoans = async (status, page) => {
    checkToken()
    try {
        setLoading(true);
        const {data} = await getLoans(status, page)
        setLoans([...loans, ...data.data.page])
        setTotalPages(data.data.totalPages)
        setLoading(false);
        return [true,data.data]
      } catch (error) {
        setLoading(false);
        console.log(error.response)
        setLoans([])
        return [false]
    }
  }

  const UpdateLoans = async (dataa) => {
    checkToken()
    setLoading(true);
    try {
        const { data } = await putLoans(dataa);
        setLoading(false);
        return true;
    } catch (error) {
        setLoading(false);
    }
}

  return {
    loans,
    getAllLoans,
    UpdateLoans,
    totalPages
  }
}
